import { render } from "./Button.vue?vue&type=template&id=480dd224&scoped=true"
const script = {}

import "./Button.vue?vue&type=style&index=0&id=480dd224&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480dd224"]])

export default __exports__